import CorrectIcon from "#/assets/exam-results/correct.svg?url";
import CorrectNotChecked from "#/assets/exam-results/CorrectNotChecked.svg";
import UncheckedIcon from "#/assets/exam-results/unchecked.svg?url";
import WrongIcon from "#/assets/exam-results/wrong.svg?url";
import { Tooltip, useBreakLG } from "@monta/design-system";
import clsx from "clsx";
import type React from "react";
import { Fragment, useMemo } from "react";
import styles from "./styles.module.scss";

type Props = {
  correctChoice: number;
  selectedChoice: number;
};

const CHOICES = [1, 2, 3, 4] as const;

const QStatus: React.FC<Props> = ({ correctChoice, selectedChoice }) => {
  const isDesktop = useBreakLG();

  const questionStatus = useMemo(
    () =>
      CHOICES.map((choice) => {
        let Icon: React.ReactNode;
        let text: string;

        if (!selectedChoice && correctChoice === choice) {
          Icon = (
            <img width={20} height={20} src={UncheckedIcon} alt="انتخاب نشده" />
          );
          text = "گزینه درست (نزده)";
        } else if (
          correctChoice === choice &&
          correctChoice === selectedChoice
        ) {
          Icon = <img width={20} height={20} src={CorrectIcon} alt="صحیح" />;
          text = "درست زدی";
        } else if (correctChoice === choice && selectedChoice !== choice) {
          Icon = (
            <img
              width={20}
              height={20}
              src={CorrectNotChecked}
              alt="صحیح انتخاب نشده"
            />
          );
          text = "گزینه درست (غلط زدی)";
        } else if (selectedChoice === choice && correctChoice !== choice) {
          Icon = <img width={20} height={20} src={WrongIcon} alt="غلط" />;
          text = "غلط زدی";
        } else {
          Icon = <div className={clsx(styles.status__box)}>{choice}</div>;
          text = `گزینه ${choice}`;
        }

        return { choice, Icon, text };
      }),
    [correctChoice, selectedChoice],
  );

  return (
    <div className={styles.status}>
      {questionStatus.map(({ choice, Icon, text }) =>
        isDesktop ? (
          <Tooltip
            key={choice}
            text={text}
            bgColor="neutral-400"
            color="#344054"
          >
            {Icon}
          </Tooltip>
        ) : (
          <Fragment key={choice}>{Icon}</Fragment>
        ),
      )}
    </div>
  );
};

export default QStatus;
